import { TrackerService } from '@shared/services/tracker.service';
import { StoreService } from '@shared/services/store.service';
import type { Logger } from '@core/model/domain/logger';
import { SignalR } from '@core/model/framework/notifications/signalR';

export class InitVM {
  constructor(
    private storeService: StoreService,
    private logger: Logger
  ) {}

  async initializeTaggingTracker(isTrackingEnabled: boolean, tracker: TrackerService) {
    const taggingInitDataInBase64 = this.storeService.getVariable('TAGGING_INIT_DATA_IN_BASE64');

    if (isTrackingEnabled) {
      if (taggingInitDataInBase64 == null) {
        this.logger.logTrace('ERROR - No tagging provided - Tagging tracker not initialized');
      } else {
        await tracker.initializeTaggingTracker(taggingInitDataInBase64);
      }
    }
  }

  async initializeSignalR(isSignalREnabled: boolean, signalR: SignalR) {
    if (isSignalREnabled) {
      await signalR.ensureInitialization(this.storeService.getVariableOrThrow('OPEN_BANKING_USER_TOKEN'));
    }
  }
}
